import React, { useCallback, useLayoutEffect, useRef } from "react";
import { Textarea } from "../ui/textarea";

export const AutoGrowTextarea = ({ value, rows = 4, className = "", ...props }) => {
  const ref = useRef(null);
  const resize = useCallback(() => {
    const input = ref.current;
    if (!input) return;
    const styles = window.getComputedStyle(input);
    const border = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
    input.style.height = "auto";
    input.style.height = `${Math.ceil(input.scrollHeight + border)}px`;
  }, []);

  useLayoutEffect(resize, [value, rows, resize]);
  useLayoutEffect(() => {
    const input = ref.current;
    if (!input) return;
    let width;
    let frame;
    // Only respond to width changes, not our own height updates.
    const observer = new ResizeObserver(([entry]) => {
      if (width === undefined) { width = entry.contentRect.width; return; }
      if (Math.abs(entry.contentRect.width - width) < 0.5) return;
      width = entry.contentRect.width;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(resize);
    });
    observer.observe(input);
    document.fonts?.ready.then(() => { if (ref.current) resize(); });
    return () => { observer.disconnect(); cancelAnimationFrame(frame); };
  }, [resize]);

  return <Textarea ref={ref} value={value} rows={rows} {...props}
    className={`w-full min-w-0 resize-none overflow-hidden rounded-sm border-neutral-300 bg-white px-4 py-3 !text-base leading-7 shadow-none focus-visible:ring-[#c99658] ${className}`}
    style={{ overflowWrap: "anywhere", minHeight: rows >= 4 ? "136px" : "80px" }} />;
};